import { ChangeEvent, FC } from 'react';

interface TextFieldProps {
  name?: string;
  type?: string;
  value?: string | number;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  classes?: string;
  disabled?: boolean;
  inputClasses?: string;
}

const SearchField: FC<TextFieldProps> = ({
  placeholder,
  type,
  disabled,
  classes = '',
  onChange,
  onBlur,
  value,
  inputClasses = '',
}) => {
  return (
    <div
      className={`
        flex gap-2 border border-[#E2E8F0] rounded-md bg-transparent px-2 py-1.5
        items-center text-[14px] w-full ${classes}`}
    >
      <i className="icon-search" />
      <input
        type={type || 'text'}
        placeholder={placeholder || 'Search...'}
        className={`border-0 focus:border-0 focus:outline-0 bg-transparent w-full ${inputClasses}`}
        disabled={disabled}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
      />
    </div>
  );
};

export default SearchField;
